import { apiClient } from "lib/apiClient";
import { IResearchVersionRequest } from "features/Research/types";

export const cancelResearchDemand = async (
  workItemId: string,
  demandId: string,
  request: IResearchVersionRequest
): Promise<void> => {
  await apiClient.delete(
    `/research/work-items/${workItemId}/demands/${demandId}`,
    { params: { version: request.version } }
  );
};
